import { render } from "./slidecrown-27.vue?vue&type=template&id=2e1530ac&scoped=true"
import script from "./slidecrown-27.vue?vue&type=script&lang=js"
export * from "./slidecrown-27.vue?vue&type=script&lang=js"

import "./slidecrown-27.vue?vue&type=style&index=0&id=2e1530ac&class=scss&scoped=true&lang=css"

import exportComponent from "/Users/dima/Projects/OrangeStatic/rise-homestories/public/themes/rise-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e1530ac"]])

export default __exports__